import { Component, OnInit } from '@angular/core';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';

@Component({
  selector: 'app-configuracion-plugin',
  templateUrl: './configuracion-plugin.component.html',
  styleUrls: ['./configuracion-plugin.component.css']
})
export class ConfiguracionPluginComponent implements OnInit {

  permiso: string = "";
  idSubsector: string = "";
  nombreModulo: string = " Bandeja de Solicitudes";
  menu: any = [];
  menuVisibles = [];


  constructor(public xsAppConfigService: XsAppConfigService) { }

  ngOnInit() {
    this.idSubsector = this.xsAppConfigService.ID_SUBSECTOR;
    this.inicializarMenu();
    this.menu.id = '1';
  }

  inicializarMenu() {
    this.permiso = this.xsAppConfigService.APLICACION_PERFIL;
    this.menu = [
      { id: 1, nombre: "BANDEJA DE SOLICITUDES" },
    ];

    switch (this.permiso) {
      case "":
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;
      case "ADMINISTRADOR":
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;

      case "ADMINISTRADO":
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;

      case "SUPERVISOR":
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;

      case "GERENCIA":
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;

      default:
        // SOLO PARA PRUEBAS EN LOCAL
        this.menuVisibles.push(this.menu[0]); // BANDEJA DE SOLICITUDES
        break;
    }
  }

  mostrarLista(m) {
    console.log("--> Cargando");
    switch (m.id) {
      case 1:
        this.menu.id = '1';
        this.nombreModulo = " Bandeja de Solicitudes";
        break;
      default:
        console.log("Ops. Ocurrió un problema mostrando lista")
        break;
    }
  }
}
